import SingletonService from 'services/utils/singletonService';
import generalConfig from 'services/metaData/generalConfig';
import http from './utils/http';

const api = 'captcha';

class Captcha {
    // eslint-disable-next-line class-methods-use-this
    async checkDisplayCaptcha() {
        if (generalConfig().forceCaptcha) {
            return true;
        }

        const apiUrl = '/partners/auth/captcha';
        return http.get(apiUrl, false).then((res) => res.data.captcha)
            .catch(() => true);
    }
}

const singletonService = new SingletonService(api);
if (!singletonService.isInitialized()) {
    singletonService.setService(new Captcha());
}

export default singletonService.getService();
